import { type CountryCode } from '@webapp/core/entities/external/Country'
import {
  type PaymentMethodType,
  PaymentMethodTypes,
} from '@webapp/models/enums'
import messages from './messages'
import { useFeatureFlag } from '../useFeatureFlag'
import { useProcurifyIntl } from '../useProcurifyIntl'

export function useFormatPaymentMethodType() {
  const intl = useProcurifyIntl()

  const PAY_2971_AIRWALLEX_BENEFICIARIES = useFeatureFlag(
    'PAY_2971_AIRWALLEX_BENEFICIARIES'
  )

  return (
    paymentMethodType: PaymentMethodType,
    bankAccountCountryCode?: CountryCode,
    paymentRail?: string
  ): string => {
    if (PAY_2971_AIRWALLEX_BENEFICIARIES) {
      switch (paymentMethodType) {
        case PaymentMethodTypes.OTHER:
        case PaymentMethodTypes.CHECK:
        case PaymentMethodTypes.ACH:
          return intl.formatMessage(messages.externalLabel)
        case PaymentMethodTypes.EFT:
        case PaymentMethodTypes.WIRE:
        case PaymentMethodTypes.PROCURIFY_WIRE:
        case PaymentMethodTypes.PROCURIFY_CHECK:
        case PaymentMethodTypes.PROCURIFY_ACH:
        case PaymentMethodTypes.AIRWALLEX:
          return `${bankAccountCountryCode} ${paymentRail}`
        default:
          return null
      }
    } else {
      switch (paymentMethodType) {
        case PaymentMethodTypes.OTHER:
          return intl.formatMessage(messages.externalOtherLabel)
        case PaymentMethodTypes.CHECK:
          return intl.formatMessage(messages.externalCheckLabel)
        case PaymentMethodTypes.ACH:
          return intl.formatMessage(messages.externalAchLabel)
        case PaymentMethodTypes.EFT:
          return intl.formatMessage(messages.procurifyEftLabel)
        case PaymentMethodTypes.WIRE:
          return intl.formatMessage(messages.externalWireLabel)
        case PaymentMethodTypes.PROCURIFY_WIRE:
          return intl.formatMessage(messages.procurifyWireLabel)
        case PaymentMethodTypes.PROCURIFY_CHECK:
          return intl.formatMessage(messages.procurifyCheckLabel)
        case PaymentMethodTypes.PROCURIFY_ACH:
          return intl.formatMessage(messages.procurifyAchLabel)
        case PaymentMethodTypes.AIRWALLEX:
          return `${bankAccountCountryCode} ${paymentRail}`
        default:
          return null
      }
    }
  }
}
